import { ACTION_GET_PAYMENT_RATE, ACTION_GET_PAYMENT_RATE_ERROR, ACTION_GET_PAYMENT_RATE_SUCCESS } from "."
import * as api from "../../../api"
import * as authActions from "../../auth/actions";

export const getPaymentRateRequest = (access_token, channels, appInfo, url) => ({
    type: ACTION_GET_PAYMENT_RATE,
    payload: {
        access_token,
        channels,
        appInfo,
        url
    }
})

export const getPaymentRateSuccess = data => ({
    type: ACTION_GET_PAYMENT_RATE_SUCCESS,
    payload: {
        data
    }
})


export const getPaymentRateError = (msg) => ({
    type: ACTION_GET_PAYMENT_RATE_ERROR,
    payload: {
        msg
    }
})

export const getPaymentRate = (access_token, channels, appInfo, url) => {
    return dispatch => {
        dispatch(getPaymentRateRequest(access_token, channels, appInfo, url))
        api.getPayRate(access_token, channels, appInfo, url)
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(getPaymentRateError("error"));
                    return
                }

                const {currency, currencySymbol, lists} = data
                dispatch(getPaymentRateSuccess({currency, currencySymbol, lists}));
            }).catch((err) => {

                console.log(err)

                if (err.response) {
                    if (err.response.status === 401) {
                        dispatch(authActions.logout())
                        return
                    }
                }

                dispatch(getPaymentRateError("system error"))
            });
    }
}
